import React from "react";
import { Button, Flex, Popconfirm } from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  EyeOutlined,
} from "@ant-design/icons";

import { NavigationPath, getPopupName, history } from "../../utils";
import { ActionButtonsType } from "../../models";

const ActionButtons = ({
  navigateToAdd,
  navigateToEdit,
  handleDelete,
  navigateToDetails,
  selected,
}: ActionButtonsType) => {
  const popConfirmTitle = () => {
    const location = history.location.pathname;

    const singleOfferResponsesPattern = /^\/offer-request\/[^/]+\/responses$/;
    const isSingleOfferResponsesRoute =
      singleOfferResponsesPattern.test(location);

    switch (true) {
      case location === NavigationPath.USERS_ROUTE:
        return selected?.length === 1
          ? `Obriši korisnika ${getPopupName(selected[0])}`
          : `Obriši izabrane korisnike`;
      case location === NavigationPath.INSURANCE_ROUTE:
        return selected?.length === 1
          ? `Obriši ${getPopupName(selected[0])}`
          : `Obriši izabrana osiguravajuća društva`;
      case location === NavigationPath.OFFER_RESPONSES_ROUTE:
        return selected?.length === 1
          ? `Obriši sve odgovore na zahtjev ${getPopupName(selected[0])}`
          : `Obriši sve odgovore na izabrane zahtjeve`;
      case location === NavigationPath.OFFER_REQUESTS_ROUTE:
        return selected?.length === 1
          ? `Obriši ${getPopupName(selected[0])}`
          : `Obriši izabrane zahtjeve`;
      case isSingleOfferResponsesRoute:
        return selected?.length === 1
          ? `Obriši ${getPopupName(selected[0])}`
          : `Obriši izabrane odgovore`;
      default:
        return "Obriši";
    }
  };

  return (
    <Flex gap="small">
      {navigateToAdd && (
        <Button
          onClick={navigateToAdd}
          className="text-sm text-white bg-primary font-medium rounded-sm border-primary shadow-sm sm:w-auto md:w-[132px]"
        >
          <PlusOutlined className="hidden sm:inline-flex" />
          <span className="ms-0 sm:ms-2">Dodaj</span>
        </Button>
      )}
      {navigateToEdit && (
        <Button
          onClick={navigateToEdit}
          className="text-sm text-white bg-secondary font-medium rounded-sm border-secondary shadow-sm sm:w-auto md:w-[132px]"
          disabled={selected?.length !== 1}
        >
          <EditOutlined className="hidden sm:inline-flex" />
          <span className="ms-0 sm:ms-2">Uredi</span>
        </Button>
      )}
      {navigateToDetails && (
        <Button
          onClick={navigateToDetails}
          className="text-sm text-white bg-secondary font-medium rounded-sm border-secondary shadow-sm sm:w-auto md:w-[132px]"
          disabled={selected?.length !== 1}
        >
          <EyeOutlined className="hidden sm:inline-flex" />
          <span className="ms-0 sm:ms-2">Pogledaj</span>
        </Button>
      )}
      <Popconfirm
        okType="default"
        title={popConfirmTitle}
        onConfirm={handleDelete}
        okText="Da"
        cancelText="Ne"
      >
        <Button
          disabled={!selected || selected?.length === 0}
          className="text-sm text-white bg-ternary font-medium rounded-sm border-primary shadow-sm sm:w-auto md:w-[132px]"
        >
          <DeleteOutlined className="hidden sm:inline-flex" />
          <span className="ms-0 sm:ms-2">Obriši</span>
        </Button>
      </Popconfirm>
    </Flex>
  );
};

export default ActionButtons;
